import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=e5bc97ba&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=e5bc97ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bc97ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5bc97ba')) {
      api.createRecord('e5bc97ba', component.options)
    } else {
      api.reload('e5bc97ba', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=e5bc97ba&scoped=true&", function () {
      api.rerender('e5bc97ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zpk3kgy1cvL6/JS/comp/PopupBox.vue"
export default component.exports